import { useContext, useEffect, useState } from "react";
import { ExploreContext } from "context/ExploreContext";
import LeftSection from "./components/LeftSection";
import "./style.scss";
import RightSection from "./components/RightSection";
import { useSaveSearch, useSearchProfiles } from "hooks/api/useSearch";
import { useLocation } from "react-router-dom";
import AlertNotification from "components/CustomWidgets/alertNotification";

function Search() {
  const { setLoading, filterData } = useContext(ExploreContext);
  const [pagination, setPagination] = useState(1);
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const keyword = params.get("k");
  const search_type = +params.get("st");

  // search result api
  const { data, isLoading } = useSearchProfiles({
    page: pagination,
    limit: 8,
    keyword: keyword,
    filter_data: JSON.stringify(filterData),
  });

  // save api
  const { mutate: saveMutation } = useSaveSearch({
    onSuccess: (data) => {
      AlertNotification("success", data.message || "Search saved successfully");
    },
  });

  useEffect(() => {
    if (isLoading) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [isLoading]);

  return (
    <>
      <div className="container pb-8 pt-12 search-result-page">
        <LeftSection
          isDisabled={!keyword && !search_type}
          isLoading={false}
          searchType={search_type}
          onClick={() => {
            const cleanObject = (obj) => {
              const cleaned = {};

              for (const [key, value] of Object.entries(obj)) {
                // Skip if value is null, undefined, empty string, or contains "undefined"
                if (
                  value === null ||
                  value === undefined ||
                  value === "" ||
                  (typeof value === "string" && value.includes("undefined"))
                ) {
                  continue;
                }

                // Skip empty arrays
                if (Array.isArray(value) && value.length === 0) {
                  continue;
                }

                // If value is an object (but not array), clean it recursively
                if (typeof value === "object" && !Array.isArray(value)) {
                  const nestedCleaned = cleanObject(value);
                  // Only add if the nested object has any properties
                  if (Object.keys(nestedCleaned).length > 0) {
                    cleaned[key] = nestedCleaned;
                  }
                } else {
                  cleaned[key] = value;
                }
              }

              return cleaned;
            };
            const availableData = cleanObject(filterData);
            saveMutation({
              search_type: search_type, // keyword - 1, Advanced - 2
              search_mode: 2, // 1 = auto, 2 = manual
              filter_data: availableData,
              keyword,
            });
          }}
        />
        <RightSection
          search_type={search_type}
          count={data?.pagination_details}
          data={data?.users_data}
          current={pagination}
          setCurrent={setPagination}
          searchText={keyword}
        />
      </div>
    </>
  );
}

export default Search;
